<template>
<div class="m-0">
    <vac
        @process="checkCanActiveBlockedPublisher($event)"
        state="beforeStart"
        id="clock"
        :end-time="countdown.endAt"
        :start-time="countdown.startAt"
        class="text-affili-coral font-weight-bold"
    >
        <span

            class="time d-block"
            slot="process"
            slot-scope="{ timeObj }"
        >
            <span v-if="hasDays(timeObj)"> {{ timeObj.d }} {{ $t('time.day') }} </span>
            <span v-if="hasHours(timeObj)"> {{ timeObj.h }} {{ $t('time.hour') }} </span>
            <span v-if="hasMinutes(timeObj)"> {{ timeObj.m }} {{ $t('time.minute') }} </span>
            {{ timeObj.s }} {{ $t('time.second') }}
        </span>
        <span class="time-finished d-block" slot="finish">{{ $t('store.finished') }}</span>
    </vac>
    <CAlert color="affili-coral" class="px-1 w-100 mt-1">
        {{ $t('publisher.notice_when_block_user') }}
    </CAlert>
</div>
</template>

<script>
import { checkCanActiveBlockedPublisher, countdown } from './methods'

export default {
    name: 'Countdown',
    data: function() {
        return {
            canActiveBlocked: true,
        }
    },
    props: {
        publisher: {
            type: Object,
            required: true,
        }
    },
    computed: {
        countdown() {
            return countdown(this.publisher)
        }
    },
    methods: {
        hasDays(time) {
            return time.d != 0
        },
        hasHours(time) {
            return time.d != 0 || time.h != 0
        },
        hasMinutes(time) {
            return time.d != 0 || time.h != 0 || time.m != 0
        },
        checkCanActiveBlockedPublisher(e) {
            this.publisher.canActiveBlocked = checkCanActiveBlockedPublisher(this.publisher)
        }
    }
}
</script>